import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Spin, Tooltip, Icon } from 'antd';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import { DefaultParams } from '../../constants/people';

class ColorBox extends PureComponent {
    static contextTypes = {
        activeKey: PropTypes.string,
        handleExpand: PropTypes.func
    }

    state = {
        data: {},
        loading: false,
    }

    componentDidMount() {
        if (this.props.params.date) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refresh !== this.props.refresh) {
            this.loadData();
        }
    }

    loadData = () => {
        const { activeKey } = this.context;
        const { moduleType, params } = this.props;
        const { areaParams, hasCheckedArea, ...rest } = params;
        this.setState({ loading: true });
        Fetch.post(API_URL.dashboard.queryEmployeeAnalysisColorBlock, {
            moduleType,
            ...rest,
            ...areaParams,
            ...DefaultParams[activeKey]
        }).then(res => {
            this.setState({
                loading: false,
                data: res.data
            });
        });
    }

    getCompareDom = (type) => {
        const { data } = this.state;
        const value = data[`${type}On${type.replace(/^\w/, m => m.toUpperCase())}`];
        let dom;
        if (value > 0) {
            dom = <Icon key="icon" style={{ color: '#F00', fontSize: "6px" }} type="caret-up" />;
        } else if (value < 0) {
            dom = <Icon key="icon" style={{ color: '#0F0', fontSize: "6px" }} type="caret-down" />;
        } else if (!value || value === 0) {
            dom = <Icon key="icon" type="minus" />;
        };

        return [
            dom,
            <span key="value">{Math.abs(value || 0)}%</span>
        ];
    }

    render() {
        const { handleExpand } = this.context;
        const { title, backgroundImage, unit, showCompare, toType, params } = this.props;
        const { loading, data } = this.state;
        const { first, second } = data;
        return (
            <div className="colorBox" style={{ backgroundImage: `url(../../../../images/${backgroundImage}.png)` }}>
                <Spin spinning={loading}>
                    <Tooltip placement="top" title={title}>
                        <p className="colorTitle hidden">{title}</p>
                    </Tooltip>
                    <p className="colorData">
                        {
                            `${first || 0}${unit||""}`
                        }
                    </p>
                    {
                        showCompare &&
                        <div className="colorCompare">
                            <p>
                                <span>月环比</span>
                                {this.getCompareDom('month')}
                            </p>
                            <p>
                                <span>同&nbsp;&nbsp;&nbsp;&nbsp;比</span>
                                {this.getCompareDom('year')}
                            </p>
                        </div>
                    }
                </Spin>
                { toType && <div className="colorMore" onClick={() => handleExpand(toType, params)}>MORE</div> }
            </div>
        );
    }
}

export default ColorBox;


// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/components/ColorBox.js